import React, { Suspense } from 'react'
import {
    CustomerCenter,
    WorkBench,
    SetCenter,
    Statistics,
    MedicalAdjustment,
    Ticket
} from './containers'
import { Route , Switch} from 'react-router-dom'

const routes = (
    <Suspense fallback={<div style={{ textAlign: 'center', margin: 20 }}>加载中...</div>}>
        <Switch>
            <Route path="/medicalAdjustment" component={MedicalAdjustment} />
            <Route path="/ticket" component={Ticket} />
            <Route path="/workBench" component={WorkBench} />
            <Route path="/customerCenter" component={CustomerCenter} />
            <Route path="/statistics" component={Statistics} />
            <Route path="/setCenter" component={SetCenter} />
        </Switch>
    </Suspense>
);

export default routes
